/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgImage64(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={64}
      height={64}
      fill='none'
      viewBox='0 0 64 64'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={2}
        d='M57 5H7v54h50V5z'
      />
      <circle cx={20} cy={18} r={5} stroke='currentColor' strokeWidth={2} />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={2}
        d='M56.028 37.5L40.5 21.52 25.896 37 20.5 31.5 7.5 45'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={2}
        d='M7.783 45L20.5 31.52 25.825 37'
      />
    </svg>
  );
}

export default SvgImage64;
